import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { HousingFundsStyled } from '../../../asset/styled/deductions/HousingFundsStyled';
import titleImg from '../../../asset/img/housingfunds_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';
import HousingFundsCheckList from './HousingFundsCheckList';
import Typography from '../../../components/common/Typography';
import Type1 from './Type1';
import Type2 from './Type2';
import Type3 from './Type3';
import Type4 from './Type4';

import Type1CheckList from './checklist/Type1';
import Type2CheckList from './checklist/Type2';
import Type3CheckList from './checklist/Type3';
import Type4CheckList from './checklist/Type4';

import Type1Detail from './detail/Type1';
import Type2Detail from './detail/Type2';
import Type3Detail from './detail/Type3';
import Type4Detail from './detail/Type4';

import {
  getHousingFundsData,
  getHousingFundsData1,
  getHousingFundsData2,
  getHousingFundsData3,
  resetHousingFundsState,
} from './housingFundsSlice';
import EmptyHousingFund from './EmptyHousingFund';
import SlideDialogV from '../../../components/common/SlideDialogV';

const HousingFunds = () => {
  const isOpenInitial = {
    checkList: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },
    detail: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },
  };
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/housingFunds');
  const { s10Data, isRender, reload } = useSelector(state => state.housingFunds);
  // 분양권의 경우는 장기주택, 주택임차 동시에X
  const [isSlideDialogVOpen2, setIsSlideDialogVOpen2] = useState(false);
  //분양권 한번 뜨면 안뜨게 처리하는 용도(Math.random() 사용)
  const [checkSlideDialogVOpen2, setCheckSlideDialogVOpen2] = useState(true);
  const [isOpen, setIsOpen] = useState({
    checkList: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },

    detail: {
      type1: false,
      type2: false,
      type3: false,
      type4: false,
    },
  });

  //최초 렌더링
  useEffect(() => {
    const fetchData = async () => {
      if (!isRender) {
        const result = await dispatch(getHousingFundsData());
        if (result.payload && result.payload.htmJType === '1') {
          dispatch(getHousingFundsData1()); //주택임차차입금, 장기주택
          dispatch(getHousingFundsData2()); //주택마련저축
          dispatch(getHousingFundsData3()); //월세액
        }
      }
    };

    fetchData();
  }, []);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetHousingFundsState());
    };
  }, []);

  //체크, 상세 저장,삭제시 데이터 다시 불러옴
  useEffect(() => {
    if (reload != -1) {
      fetchData();
    }
  }, [reload]);

  //체크리스트, 상세 슬라이드 닫힐때 스크롤 맨 위로
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isOpen]);

  //분양권 뜨는 팝업
  useEffect(() => {
    if (s10Data.htm102 === '1' && s10Data.htm103 === '1') {
      setIsSlideDialogVOpen2(true);
    }
  }, [s10Data]);

  const fetchData = async () => {
    const result = await dispatch(getHousingFundsData());
    if (result.payload && result.payload.htmJType === '1') {
      dispatch(getHousingFundsData1()); //주택임차차입금, 장기주택
      dispatch(getHousingFundsData2()); //주택마련저축
      dispatch(getHousingFundsData3()); //월세액
    }
  };

  const handleOpen = (type, detail) => {
    setIsOpen(prev => {
      isOpenInitial[detail][type] = true;

      return isOpenInitial;
    });
  };

  const onClose = () => {
    setIsOpen(isOpenInitial);
  };

  if (!isRender) {
    return null;
  }

  if (s10Data.htmJType != '1') return <EmptyHousingFund />;

  return (
    <HousingFundsStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection badge title={t('title')} img={titleImg} />
      {(Number(s10Data.htm013) > 70000000 || Number(s10Data.htm013) > 80000000) && (
        <div>
          {/* 총 급여 7000만원 초과 근로자로 월세액, 주택마련 불가 */}
          <Typography variant="body2Medium" color="GrayScale-700">
            {Number(s10Data.htm013) > 80000000
              ? t('description.normal2')
              : t('description.normal1')}
            <span className="body2Bold">
              {/* 총 급여 8000만원 초과 근로자로 월세액, 주택마련 불가
                  총 급여 7000만원 초과 근로자로 주택마련
              */}
              {Number(s10Data.htm013) > 80000000 ? t('description.bold2') : t('description.bold1')}
            </span>
            <span className="body2Medium textGrayScale700">{t('description.normal3')}</span>
          </Typography>
        </div>
      )}
      {s10Data.htmJType == '1' && (
        <>
          <HousingFundsCheckList onOpen={handleOpen} />

          {/* 주택임차 */}
          {s10Data.htm102 == '1' && <Type1 onOpen={handleOpen} />}
          {/* 장기주택 */}
          {s10Data.htm103 == '1' && <Type2 onOpen={handleOpen} />}
          {/* 주택마련저축 */}
          {s10Data.htm013 <= 70000000 && s10Data.htm104 == '1' && <Type3 onOpen={handleOpen} />}
          {/* 월세액 */}
          {s10Data.htm013 <= 80000000 && s10Data.htm105 == '1' && <Type4 onOpen={handleOpen} />}
        </>
      )}

      {<Type1CheckList isOpen={isOpen.checkList.type1} onClose={onClose} onOpen={handleOpen} />}
      {<Type2CheckList isOpen={isOpen.checkList.type2} onClose={onClose} onOpen={handleOpen} />}
      {<Type3CheckList isOpen={isOpen.checkList.type3} onClose={onClose} onOpen={handleOpen} />}
      {<Type4CheckList isOpen={isOpen.checkList.type4} onClose={onClose} onOpen={handleOpen} />}

      <Type1Detail isOpen={isOpen.detail.type1} onClose={onClose} />
      <Type2Detail isOpen={isOpen.detail.type2} onClose={onClose} />
      <Type3Detail isOpen={isOpen.detail.type3} onClose={onClose} />
      <Type4Detail isOpen={isOpen.detail.type4} onClose={onClose} />
      {/* 분양권의 경우는 장기주택, 주택임차 동시에X */}
      <SlideDialogV
        isOpen={isSlideDialogVOpen2 && checkSlideDialogVOpen2}
        onClose={() => {
          setIsSlideDialogVOpen2(false);
          setCheckSlideDialogVOpen2(false);
        }}
        title={t('slideDialog.title')}
        description={t('slideDialog.description')}
        buttons={[
          {
            label: t('slideDialog.button'),
            onClick: () => {
              setIsSlideDialogVOpen2(false);
              setCheckSlideDialogVOpen2(false);
            },
          },
        ]}
      />
    </HousingFundsStyled>
  );
};

export default HousingFunds;
